import { render, staticRenderFns } from "./HealthReportSchedule.vue?vue&type=template&id=081038d4&scoped=true"
import script from "./HealthReportSchedule.vue?vue&type=script&lang=js"
export * from "./HealthReportSchedule.vue?vue&type=script&lang=js"
import style0 from "./HealthReportSchedule.vue?vue&type=style&index=0&id=081038d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081038d4",
  null
  
)

export default component.exports